﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customUserImportList from './tpl/customUserImportList.html';
import View_CustomUserImportListItem from './customUserImportListItem';

export default Marionette.CollectionView.extend({
    childViewContainer: '#customUserImportList',
    childView: View_CustomUserImportListItem,
    getTemplate: function () {
        return tpl_customUserImportList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});